export const JUMP_TO_TOP_DEFAULT = false;

const IGNORE_URLS = ['outer', 'orders/cart_status'];

function normalizeUrlPath(requestUrl) {
  if (!requestUrl) return '';
  let path = String(requestUrl).split('?')[0];
  if (path.startsWith('/')) {
    path = path.substring(1);
  }
  return path;
}

function shouldIgnoreJumpToTopUrl(requestUrl) {
  const path = normalizeUrlPath(requestUrl);
  return IGNORE_URLS.some((u) => path === u || path.startsWith(u + '/'));
}

function hasJumpToTopFlag(data) {
  if (!data || typeof data !== 'object') return false;
  if (data.show_jump_to_top === true) return true;
  // Page payloads are often nested (e.g. home JSON lives under `home`).
  for (const key of ['home', 'search', 'cook']) {
    if (data[key]?.show_jump_to_top === true) return true;
  }
  return false;
}

/** Keep jump-to-top when opening/closing the dish overlay on the same cook page. */
export function shouldResetJumpToTopOnNavigation(to, from) {
  if (!from?.name) return true;
  if (to.name === 'dish' && from.name === 'cook' && to.params.cookid === from.params.cookid) {
    return false;
  }
  if (to.name === 'cook' && from.name === 'dish' && to.params.cookid === from.params.cookid) {
    return false;
  }
  return true;
}

export function maybeEnableJumpToTop(store, requestUrl, data) {
  if (!store) return;
  if (shouldIgnoreJumpToTopUrl(requestUrl)) return;
  if (hasJumpToTopFlag(data)) {
    store.dispatch('setShowJumpToTop', true);
  }
}
